(function () {
  console.log('[fallback] Script loaded (targeting Searchanise widget).');

  var STOREFRONT_TOKEN = 'ee831c0f0b28c39a94171b98a2b43b6d';
  var API_VERSION = '2026-07';

  var allCollections = null;
  var isFetching = false;
  var fetchQueue = [];
  function isCollectionSearchEnabled() {
    return !!(window.SHOP_SETTINGS && window.SHOP_SETTINGS.showCollectionInSearch === true);
  }
  function fetchAllCollections(cursor, accumulated) {
    accumulated = accumulated || [];
    var query = `
      query ($cursor: String) {
        collections(first: 250, after: $cursor) {
          pageInfo { hasNextPage endCursor }
          edges {
            node {
              handle
              title
              image { url(transform: { maxWidth: 100, maxHeight: 100 }) }
            }
          }
        }
      }`;

    return fetch('/api/' + API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query: query, variables: { cursor: cursor || null } }),
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.errors) console.error('[fallback] GraphQL errors:', json.errors);
        var page = json.data.collections;
        var collected = accumulated.concat(page.edges.map(function (e) { return e.node; }));
        console.log('[fallback] Fetched page:', page.edges.length, 'collections. Total so far:', collected.length);
        if (page.pageInfo.hasNextPage) {
          return fetchAllCollections(page.pageInfo.endCursor, collected);
        }
        console.log('[fallback] All collections fetched:', collected.length);
        return collected;
      });
  }

  function getCollections() {
    if (allCollections) return Promise.resolve(allCollections);
    if (isFetching) return new Promise(function (resolve) { fetchQueue.push(resolve); });
    isFetching = true;
    return fetchAllCollections().then(function (collections) {
      allCollections = collections;
      isFetching = false;
      fetchQueue.forEach(function (resolve) { resolve(collections); });
      fetchQueue = [];
      return collections;
    });
  }

  function buildMatchesHTML(matches) {
    var html = '<div class="js-collection-fallback-injected" style="padding: 0.75rem 0; border-top: 1px solid #eee; margin-top: 0.5rem;">';
    html += '<p style="margin: 0 0 0.5rem; font-weight: 600;">You might be looking for these clubs:</p>';
    html += '<ul style="list-style: none; padding: 0; margin: 0;">';
    matches.forEach(function (c) {
      html += '<li style="display: flex; align-items: center; gap: 0.5rem; padding: 0.4rem 0;">';
      if (c.image && c.image.url) {
        html += '<img src="' + c.image.url + '" alt="" width="40" height="40" style="object-fit: cover; border-radius: 4px;">';
      }
      html += '<a href="/collections/' + c.handle + '">' + c.title + '</a>';
      html += '</li>';
    });
    html += '</ul></div>';
    return html;
  }

  // function handleNothingFound(nothingFoundEl) {
  //   var termEl = nothingFoundEl.querySelector('.snize-nothing-found-text b');
  //   var term = termEl ? termEl.textContent.trim() : '';
  //   console.log('[fallback] "Nothing found" block detected. Extracted term:', JSON.stringify(term));

  //   if (!term) {
  //     console.warn('[fallback] Could not extract search term from markup — aborting.');
  //     return;
  //   }

  //   getCollections().then(function (collections) {
  //     var termLower = term.toLowerCase();
  //     var matches = collections.filter(function (c) {
  //       return c.title.toLowerCase().indexOf(termLower) !== -1;
  //     });
  //     console.log('[fallback] Matches for "' + term + '":', matches.length, matches.map(function (c) { return c.title; }));

  //     if (matches.length === 0) {
  //       console.log('[fallback] No collection matches either — nothing to inject.');
  //       return;
  //     }

  //     var injected = document.createElement('div');
  //     injected.innerHTML = buildMatchesHTML(matches);
  //     // Insert right after the "nothing found" block, as a sibling within the same
  //     // still-live container -- not a persistent node we try to protect, just a
  //     // fresh insert each time this whole block gets rebuilt.
  //     nothingFoundEl.parentNode.insertBefore(injected.firstChild, nothingFoundEl.nextSibling);
  //     console.log('[fallback] Injected', matches.length, 'collection link(s) after the nothing-found message.');
  //   });
  // }

  function handleNothingFound(nothingFoundEl) {
    if (!isCollectionSearchEnabled()) return; // setting off: leave "Sorry, nothing found" untouched
  var textEl = nothingFoundEl.querySelector('.snize-nothing-found-text');
  var termEl = textEl ? textEl.querySelector('b') : null;
  var term = termEl ? termEl.textContent.trim() : '';
  console.log('[fallback] "Nothing found" block detected. Extracted term:', JSON.stringify(term));

  if (!term || !textEl) {
    console.warn('[fallback] Could not extract search term or text element — aborting, leaving original message untouched.');
    return;
  }

  getCollections().then(function (collections) {
    var termLower = term.toLowerCase();
    var matches = collections.filter(function (c) {
      return c.title.toLowerCase().indexOf(termLower) !== -1;
    });
    console.log('[fallback] Matches for "' + term + '":', matches.length, matches.map(function (c) { return c.title; }));

    if (matches.length === 0) {
      console.log('[fallback] No collection matches -- leaving original "Sorry, nothing found" message as-is.');
      return;
    }

    // Real matches found: hide the "Sorry, nothing found" text specifically,
    // and put our results in its exact place -- not alongside it.
    textEl.style.display = 'none';

    var injected = document.createElement('div');
    injected.className = 'js-collection-fallback-injected';
    injected.innerHTML = buildMatchesHTML(matches);
    nothingFoundEl.querySelector('span').insertBefore(injected, textEl);

    console.log('[fallback] Hid original message, injected', matches.length, 'collection link(s) in its place.');
  });
}

  // Watch the whole document, since the autocomplete popup itself may be
  // created/destroyed as a unit on each search open -- we can't assume any
  // single intermediate container persists across searches.
  // var observer = new MutationObserver(function () {
  //   var nothingFoundBlocks = document.querySelectorAll('.snize-nothing-found');
  //   nothingFoundBlocks.forEach(function (block) {
  //     // Guard against re-processing the same rebuilt block twice in the same render.
  //     var alreadyInjected = block.nextSibling && block.nextSibling.classList && block.nextSibling.classList.contains('js-collection-fallback-injected');
  //     if (!alreadyInjected) {
  //       handleNothingFound(block);
  //     }
  //   });
  // });

  var observer = new MutationObserver(function () {
  var nothingFoundBlocks = document.querySelectorAll('.snize-nothing-found');
  nothingFoundBlocks.forEach(function (block) {
    var alreadyInjected = block.querySelector('.js-collection-fallback-injected') !== null;
    if (!alreadyInjected) {
      handleNothingFound(block);
    }
  });
});

    if (isCollectionSearchEnabled()) {
    observer.observe(document.body, { childList: true, subtree: true });
    console.log('[fallback] Observer attached to document.body, watching for .snize-nothing-found.');
     } else {
    console.log('[fallback] Show Collection in Search is off; collection suggestions disabled.');
    }

  // ===== ADDED: collection links in the autocomplete dropdown (while typing) =====
  // Searchanise shows "Popular suggestions" instead of "Sorry, nothing found" in the
  // dropdown, so the observer above never fires there. This block adds the club
  // collections to the top of the dropdown whenever it shows no products.
  var AC_CONTAINER = '.snize-ac-results';   // Searchanise autocomplete dropdown
  var AC_PRODUCT = '.snize-product';        // a product row inside the dropdown
  var AC_SEARCH_INPUTS = 'input[name="q"], input.snize-input-style, input[type="search"]';
  var AC_MIN_TERM_LENGTH = 3;
  var AC_MAX_MATCHES = 6;

  function getAutocompleteTerm() {
    var active = document.activeElement;
    if (active && active.matches && active.matches(AC_SEARCH_INPUTS) && active.value) return active.value.trim();
    var inputs = document.querySelectorAll(AC_SEARCH_INPUTS);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value) return inputs[i].value.trim();
    }
    return '';
  }

  function handleAutocomplete(container) {
    var term = getAutocompleteTerm();
    var existing = container.querySelector('.js-collection-ac-injected');
    var hasProducts = container.querySelector(AC_PRODUCT) !== null;

    // Products found, or term too short: remove our block if present
    if (hasProducts || term.length < AC_MIN_TERM_LENGTH) {
      if (existing) existing.remove();
      return;
    }
    // Already added for this exact term
    if (existing && existing.getAttribute('data-term') === term) return;

    getCollections().then(function (collections) {
      if (term !== getAutocompleteTerm()) return; // user kept typing
      var termLower = term.toLowerCase();
      var matches = collections.filter(function (c) {
        return c.title.toLowerCase().indexOf(termLower) !== -1;
      }).slice(0, AC_MAX_MATCHES);
      console.log('[fallback] Autocomplete has no products for "' + term + '". Collection matches:', matches.length, matches.map(function (c) { return c.title; }));

      var old = container.querySelector('.js-collection-ac-injected');
      if (old) old.remove();
      if (matches.length === 0) return;

      // Insert at the top of the dropdown, above "Popular suggestions"
      var list = container.tagName === 'UL' ? container : (container.querySelector('ul') || container);
      var wrapper = document.createElement(list.tagName === 'UL' ? 'li' : 'div');
      wrapper.className = 'js-collection-ac-injected';
      wrapper.setAttribute('data-term', term);
      wrapper.style.cssText = 'list-style: none; padding: 0 1rem;';
      wrapper.innerHTML = buildMatchesHTML(matches);
      list.insertBefore(wrapper, list.firstChild);
      console.log('[fallback] Injected', matches.length, 'collection link(s) into the autocomplete dropdown.');
    });
  }

  var acScheduled = false;
  function scanAutocomplete() {
    acScheduled = false;
    document.querySelectorAll(AC_CONTAINER).forEach(handleAutocomplete);
  }
  function scheduleAutocompleteScan() {
    if (!acScheduled) { acScheduled = true; setTimeout(scanAutocomplete, 150); }
  }

  if (isCollectionSearchEnabled()) {
    new MutationObserver(scheduleAutocompleteScan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches(AC_SEARCH_INPUTS)) scheduleAutocompleteScan();
    }, true);
    console.log('[fallback] Autocomplete observer attached, watching ' + AC_CONTAINER + ' for no-product results.');
  }
  // ===== END ADDED =====

  // window.SHOP_SETTINGS = {
  //   showCollectionInSearch: {{ shop.metafields.custom.show_collection_in_search | json }}
  // };
  console.log(window.SHOP_SETTINGS, "window.SHOP_SETTINGS")

})();